import React from 'react';

import { ContactCard } from '@components/utilities/Contact/ContactCard';
import Grid from '@material-ui/core/Grid';
import { Company } from '@models/Company';
import { Contact, ContactType } from '@models/next/Contact';
import { User } from '@models/User';
import { makeMuiStyles, useCommonStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexColumnCenter,
    minHeight: 200,
    flex: 1,
    ...common.middleText,
    color: theme.palette.grey[500],
    textAlign: 'center',
    '& a': {
      ...common.caution,
      ...common.baseButton,
      textDecoration: 'underline',
    },
  },
}));

export interface ContactGridProps {
  contactType: ContactType;
  contacts?: Contact[];
  user: User;
  company: Company;
  noDataTip: string | React.ReactNode;
}

export const ContactGrid: React.FC<ContactGridProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { contacts, noDataTip, contactType, user, company } = props;

  const editUrl = (itemId?: number) => {
    if (contactType === 'shipper') {
      return `ShipperDetails?id=${itemId}`;
    }
    return `ConsigneeDetails?id=${itemId}`;
  };

  const detailsUrl = (itemId?: number) => {
    if (contactType === 'shipper') {
      return `ShipperDetails?id=${itemId}`;
    }
    return `ConsigneeDetails?id=${itemId}`;
  };

  const renderGrid = () => {
    return (
      <Grid container spacing={2}>
        {contacts?.map((item, index) => (
          <Grid key={String(index)} item xs={12} md={6}>
            <ContactCard
              editUrl={editUrl(item.id)}
              contact={item}
              user={user}
              detailsUrl={detailsUrl(item.id)}
              company={company}
              contactType={contactType}
            />
          </Grid>
        ))}
      </Grid>
    );
  };

  const renderEmpty = () => {
    return <div className={classes.container}>{noDataTip}</div>;
  };

  return <>{contacts && contacts.length > 0 ? renderGrid() : renderEmpty()}</>;
};
